export default "__VITE_PUBLIC_ASSET__017de3ef__"